import React from 'react';
import {Select} from "antd";
import {useSelector} from "react-redux";
import {useGetUsersQuery} from "../slices/rootApiSlices/userApiSlice";

const SearchUsers = ({onChange, value}) => {

    const {user} = useSelector((state) => state.auth);
    const {data, error, isLoading} = useGetUsersQuery(user?.token);

    if (isLoading) {
        return <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>yükleniyor...</div>;
    }

    if (error) {
        return <div>Hata, lütfen bekleyiniz</div>;
    }

    return (
        <Select
            showSearch
            placeholder="Kullanıcı seçiniz"
            optionFilterProp="children"
            labelInValue
            value={value}
            onChange={onChange}
            loading={isLoading}
            filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
            }
            options={data?.data?.map(user => ({
                value: user.email, // value olarak e-posta adresini kullan
                label: user.name, // label olarak kullanıcı adını kullan
                key: user.id // AntD Select'e her option için unique bir key
            }))}
        />
    );
};

export default SearchUsers;
